import { FC } from 'react';
import { useIntercom } from 'react-use-intercom';
import { Flex, Link } from '@chakra-ui/react';

import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';

import locales from './locales';

const OngoingReviewCallout: FC = () => {
  const intercom = useIntercom();

  return (
    <Flex
      alignItems="center"
      border="1px solid"
      borderColor="border"
      borderRadius="radius-8"
      gap="space-16"
      padding="space-16"
    >
      <SquircleIcon name="switch" />

      <Text size="sm">
        {locales.callout}
        <Link onClick={() => intercom.showNewMessages()} size="sm">
          {locales.contactUs}
        </Link>
        .
      </Text>
    </Flex>
  );
};

export default OngoingReviewCallout;
